"use strict";

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React from 'react';
import ReactDOM from 'react-dom';
import SideDrawerListStore from 'Stores/SideDrawerListStore';
import * as actions from 'Actions/SideDrawerListActions';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { Fields } from "Constants/objects";
import { topBarSetDynToolBarContent } from "Actions/TopBarActions";
import { SUBSYSTEM_STR } from 'Router';
var style = {
  typoRoot: {
    paddingBottom: 0,
    paddingTop: 0,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '1.2em',
    fontSize: '0.875rem'
  }
};

var styles = function styles(theme) {
  return {
    typoLink: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    subItemRoot: _objectSpread({
      color: theme.palette.customColors.drawer.listItem.subItems.color,
      minHeight: theme.spacing.unit * 3
    }, style.typoRoot),
    subItemRootActive: _objectSpread({
      color: theme.palette.customColors.drawer.listItem.subItems.active.color,
      minHeight: theme.spacing.unit * 3
    }, style.typoRoot),
    typoRoot: _objectSpread({
      color: theme.palette.customColors.drawer.listItem.color,
      minHeight: theme.spacing.unit * 4
    }, style.typoRoot),
    itemRoot: {
      color: theme.palette.customColors.drawer.listItem.color,
      paddingBottom: 0,
      paddingTop: 0,
      overflowX: 'hidden'
    },
    textRoot: {
      paddingLeft: 0
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4
    },
    active: {
      textDecoration: 'none'
    },
    subItemIconRoot: {
      color: 'inherit',
      width: theme.spacing.unit * 2,
      height: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit,
      fontSize: theme.spacing.unit * 2
    },
    listRoot: {
      overflowY: 'auto',
      height: "100%",
      marginBottom: theme.spacing.unit / 2
    }
  };
};

var SideDrawerList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SideDrawerList, _React$PureComponent);

  function SideDrawerList(props) {
    var _this;

    _classCallCheck(this, SideDrawerList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideDrawerList).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = SideDrawerListStore.getList();
    _this.updateScrollTop = _.debounce(_this.updateScrollTop.bind(_assertThisInitialized(_assertThisInitialized(_this))), 600);
    return _this;
  }

  _createClass(SideDrawerList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      SideDrawerListStore.addChangeListener(this._onChange);
      var list = ReactDOM.findDOMNode(this);
      list.scrollTop = this.state.scrollTop;
      list.addEventListener('scroll', this.updateScrollTop);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      SideDrawerListStore.removeChangeListener(this._onChange);
      var list = ReactDOM.findDOMNode(this);
      list.removeEventListener('scroll', this.updateScrollTop);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      var state = SideDrawerListStore.getList();
      this.setState({
        list: _toConsumableArray(state.list),
        scrollTop: state.scrollTop
      });
    }
  }, {
    key: "updateScrollTop",
    value: function updateScrollTop() {
      var list = ReactDOM.findDOMNode(this);
      actions.sideDrawerListUpdScrollTop(list.scrollTop);
    }
  }, {
    key: "handleExpandClick",
    value: function handleExpandClick(e, id) {
      actions.sideDrawerListItemExpanded(id);
    }
  }, {
    key: "handleActivateClick",
    value: function handleActivateClick(formID) {
      setTimeout(function () {
        return topBarSetDynToolBarContent(null);
      });
      actions.sideDrawerListItemActivate(formID);
    }
  }, {
    key: "listItem",
    value: function listItem(li, deep) {
      var _this2 = this,
          _classNames2;

      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme;
      var style = {
        paddingLeft: "".concat(24 + theme.spacing.unit * deep, "px")
      };
      return React.createElement("a", {
        href: SUBSYSTEM_STR + li.FormID,
        className: classes.typoLink,
        key: li.ID
      }, React.createElement(ListItem, {
        button: true,
        id: "drawer-li-".concat(li.ID),
        key: "ListItem".concat(li.ID),
        classes: {
          root: classes.itemRoot
        },
        className: classNames(_defineProperty({}, classes.active, li.IsActive)),
        style: style,
        onClick: function onClick() {
          return _this2.handleActivateClick(li.FormID);
        }
      }, React.createElement(ListItemIcon, {
        key: "listItemIcon".concat(li.ID),
        classes: {
          root: classes.subItemIconRoot
        }
      }, li.IsActive ? React.createElement(RadioButtonChecked, {
        key: "rbIcon".concat(li.ID),
        fontSize: 'inherit'
      }) : React.createElement(RadioButtonUnchecked, {
        key: "rbIcon".concat(li.ID),
        fontSize: 'inherit'
      })), React.createElement(ListItemText, {
        classes: {
          root: classes.textRoot
        },
        disableTypography: true,
        key: "textID".concat(li.ID),
        primary: React.createElement(Typography, {
          variant: "body1",
          key: "liText".concat(li.ID),
          classes: {
            root: classNames((_classNames2 = {}, _defineProperty(_classNames2, classes.subItemRoot, !li.IsActive && li[Fields.ParentSubsystemID] != null), _defineProperty(_classNames2, classes.typoRoot, li[Fields.ParentSubsystemID] == null), _defineProperty(_classNames2, classes.subItemRootActive, li.IsActive), _classNames2))
          }
        }, li.Name)
      })));
    }
  }, {
    key: "parentListItem",
    value: function parentListItem(li, deep) {
      var _this3 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          theme = _this$props2.theme;
      var children = li.Children;
      var style = {
        paddingLeft: "".concat(24 + theme.spacing.unit * deep, "px")
      };
      var childDeep = deep + 1;
      var renderedChildren = [];

      _.each(children, function (child) {
        renderedChildren.push(_this3.drawListItem(child, childDeep));
      });

      return React.createElement(React.Fragment, {
        key: "fragment".concat(li.ID)
      }, React.createElement(ListItem, {
        button: true,
        key: li.ID,
        onClick: function onClick(e) {
          return _this3.handleExpandClick(e, li.ID);
        },
        classes: {
          root: classNames(classes.itemRoot)
        },
        style: style
      }, React.createElement(ListItemText, {
        color: 'inherit',
        key: "textID".concat(li.ID),
        primary: React.createElement(Typography, {
          variant: "subtitle2",
          classes: {
            root: classes.typoRoot
          }
        }, li.Name)
      }), li.Expanded ? React.createElement(ExpandLess, {
        key: "expandIcon".concat(li.ID)
      }) : React.createElement(ExpandMore, {
        key: "expandIcon".concat(li.ID)
      })), React.createElement(Collapse, {
        key: "collapseID".concat(li.ID),
        in: li.Expanded,
        className: classNames(_defineProperty({}, 'root-item', deep === 0))
      }, React.createElement(List, {
        key: "listID".concat(li.ID),
        component: "div",
        disablePadding: true
      }, renderedChildren)));
    }
  }, {
    key: "drawListItem",
    value: function drawListItem(li) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (li.IsGroup) return this.parentListItem(li, deep);
      return this.listItem(li, deep);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var list = this.state.list;
      var classes = this.props.classes;
      var renderedList = [];

      _.each(list, function (li) {
        renderedList.push(_this4.drawListItem(li));
      });

      return React.createElement(List, {
        component: "nav",
        classes: {
          root: classes.listRoot
        }
      }, renderedList);
    }
  }]);

  return SideDrawerList;
}(React.PureComponent);

_defineProperty(SideDrawerList, "propTypes", {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
});

export default withStyles(styles, {
  withTheme: true
})(SideDrawerList);